module.exports = __webpack_public_path__ + "img/bg_1.9933e08f.jpg";